
import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { SdsForm } from "soft_digi";
import { SdsFormElementProps } from "soft_digi/dist/sdforms/SdsFromInterFace";
import * as Yup from "yup";
import { QUESTIONS_URLS } from "../../api/AdminUrls";
import { useSiteContext } from "../../contexts/SiteProvider";
import { post } from "../../services/smartApiService";
import SdsImageLoader from "../../services/site/SdsImageLoader";

interface HeaderProps {
  loadTableData: () => void;
  id: any;
  dataIn: any;
}

const schema = Yup.object({
  question_image: Yup.mixed()
    .notRequired()
    .test(
      "fileType",
      "Only Images are Allowed",
      (value: any) =>
        !value || ["image/jpeg", "image/png", "image/gif"].includes(value.type)
    )
    .test(
      "fileSize",
      "File size must be less than 500 KB",
      (value: any) => !value || value.size <= 500 * 1024
    ),
});

const QuestionImageUploader: React.FC<HeaderProps> = ({
  loadTableData,
  id,
  dataIn,
}) => {
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: dataIn,
  });

  const { closeModal } = useSiteContext();
  const reloadPage = () => {
    window.location.reload();
  };
  const onSubmit = (formData: any) => {
    const url = QUESTIONS_URLS.UPLOAD_IMAGE;

    const payload = {
      id: id,
      ...formData,
    };

    const subscription = post(url, payload).subscribe(() => {
      reloadPage();
      closeModal();
    });

    return () => {
      subscription.unsubscribe();
    };
  };

  useEffect(() => {
    return () => {};
  }, []);

  const elements: SdsFormElementProps[] = [
    {
      type: "FILE",
      width: 12,
      name: "question_image",
      element: {
        label: "Browse Question Images (If Any)",
        placeHolder: "(Image Only)",
        isRequired: true,
        accept: "image/*",
        inputType: "BORDER_LABEL",
      },
    },
    {
      type: "BUTTON",
      width: 12,
      name: "submit_button",
      class_name: "has-text-right",
      element: {
        classList: ["button", "smart-action-button"],
        label: dataIn?.id ? "Update" : "Add",
        onClick: handleSubmit(onSubmit),
      },
    },
  ];

  return (
    <>
 {dataIn?.id && dataIn?.content !== false && dataIn?.question_image && (
  <div className="has-text-centered">
    <div className="is-inline-block">
      <SdsImageLoader
        name="logo"
        id={dataIn.id}
        url={QUESTIONS_URLS.GET_IMAGE}
        containerStyle={{ width: "200px", height: "200px" }}
      />
    </div>
  </div>
)}



      <div className="sd-hims-input mt-3">
        <SdsForm elements={elements} errors={errors} control={control} />
      </div>
    </>
  );
};

export default QuestionImageUploader;
